import * as keyapis_device_v1_access_pb from "./v1/keyapis_device_access_v1.pb";
import * as keyapis_device_v1_cms_phone_pb from "./v1/keyapis_device_cms_phone_v1.pb";
import * as keyapis_device_v1_command_pb from "./v1/keyapis_device_command_v1.pb";
import * as keyapis_device_v1_device_pb from "./v1/keyapis_device_device_v1.pb";
import * as keyapis_device_v1_event_alert_pb from "./v1/keyapis_device_event_alert_v1.pb";
import * as keyapis_device_v1_events_pb from "./v1/keyapis_device_events_v1.pb";
import * as keyapis_device_v1_model_pb from "./v1/keyapis_device_model_v1.pb";
import * as keyapis_device_v1_sip_phone_pb from "./v1/keyapis_device_sip_phone_v1.pb";
import * as keyapis_device_v1_system_pb from "./v1/keyapis_device_system_v1.pb";
import * as keyapis_device_v1_trunk_config_pb from "./v1/keyapis_device_trunk_config.pb";

export default {
  v1: {
    resources: {
      access: keyapis_device_v1_access_pb,
      cmsPhone: keyapis_device_v1_cms_phone_pb,
      command: keyapis_device_v1_command_pb,
      device: keyapis_device_v1_device_pb,
      eventAlert: keyapis_device_v1_event_alert_pb,
      events: keyapis_device_v1_events_pb,
      model: keyapis_device_v1_model_pb,
      sipPhone: keyapis_device_v1_sip_phone_pb,
      system: keyapis_device_v1_system_pb,
      trunkConfig: keyapis_device_v1_trunk_config_pb,
    },
  },
};
